<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Dealership Profile</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <!-- <ion-list (keydown.alt.control.arrowup)="onExecuteAutoTypeClick($event, 'dealership')"> -->

    <ion-list lines="none">
        <!-- 
        <ion-list appAutoType="dealership"> 
        I was thinking of moving this autotype business into a directive called appAutoType
        I don't remember how to do it and I don't feel like googling it, so I will leave it alone for now.
        This feature was just for me when creating tutorials.  I will do the editing in Camtasia and
        remove this feature at some point. 
    -->
        <ion-list-header color="secondary">
            Enter your dealership information:
        </ion-list-header>

        <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Dealership Name</ion-label>
                <ion-input color="dark" type="text" name="dealershipName" data-test="dealershipName"
                    #dealershipName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && dealershipName.invalid }"
                    required [(ngModel)]="dealership.dealershipName" id="dealershipName">
                </ion-input>
                @if (submitted && dealershipName.invalid) {
                <div data-test="dealershipNameErr">
                    <div class="validationErrorMsg">Dealership name is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Dealership's Phone Number</ion-label>
                <ion-input color="secondary" type="tel" name="phone" data-test="phone" #phone="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && phone.invalid }" required
                    [(ngModel)]="dealership.phoneNumber" id="phoneNumber" appPhoneMask>
                </ion-input>
                @if (submitted && phone.invalid) {
                <div data-test="phoneNumberErr">
                    <div class="validationErrorMsg">A valid phone number is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Street Address</ion-label>
                <ion-input color="secondary" type="text" name="streetAddress" data-test="streetAddress"
                    #streetAddress="ngModel" [ngClass]="{ 'is-invalid': f.submitted && streetAddress.invalid }" required
                    [(ngModel)]="dealership.address.streetAddress" minlength="6" (ionChange)="onAddressChange()"
                    id="streetAddress">
                </ion-input>
                @if (submitted && streetAddress.invalid) {
                <div data-test="streetAddressErr">
                    <div class="validationErrorMsg">Street address must be at least 6 characters.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Zipcode</ion-label>
                <ion-input color="secondary" type="text" name="zipcode" data-test="zipcode" #zipcode="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && zipcode.invalid }" required
                    [(ngModel)]="dealership.address.zipcode" id="streetAddress" minlength="5"
                    (ionChange)="onZipcodeChange()">
                </ion-input>
                @if (submitted && zipcode.invalid) {
                <div data-test="zipcodeErr">
                    <div class="validationErrorMsg">Zipcode is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">City</ion-label>
                <ion-input color="secondary" type="text" name="city" data-test="city" #city="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && city.invalid }" required
                    [(ngModel)]="dealership.address.city" id="city" (ionChange)="onZipcodeChange()">
                </ion-input>
                @if (submitted && city.invalid) {
                <div data-test="cityErr">
                    <div class="validationErrorMsg">City is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <!-- (ionChange)="onZipcodeChange()" -->
                <ion-label class="ion-text-wrap" position="stacked">State / Region</ion-label>
                <ion-input color="dark" id="state" type="text" name="state" data-test="state"
                    [(ngModel)]="dealership.address.regionName" (click)="onStateClick()"></ion-input>
            </ion-item>

            <ion-item>  <!-- (click)="onCountryClick()" -->
                <ion-label class="ion-text-wrap" position="stacked">Country</ion-label>
                <ion-input id="country" type="text" name="countryName" data-test="country"
                    [(ngModel)]="dealership.address.countryName" ></ion-input>
            </ion-item>

            @if (debugMode) {
                <ion-item>
                    <ion-label class="ion-text-wrap" position="stacked">Country Code</ion-label>
                    <ion-input id="countryCode" type="text" name="countryCode" data-test="countryCode"
                    [(ngModel)]="dealership.address.isoCountryCode" readonly></ion-input>
                </ion-item>
            }
        </form>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-button color="primary" [disabled]="vb.disabled || !f.valid" expand="full"
                        (click)="onVerifyAddressClick(f)" data-test="verifyAddress">
                        Verify Address
                    </ion-button>
                </ion-col>
                <ion-col>

                    <!--  [disabled]="!addressVerified" -->
                    <ion-button [disabled]="!isAddressVerified()" color="primary" expand="full" (click)="onSaveClick(f)"
                        data-test="saveButton">
                        Save
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-footer>